const BREAKPOINTS = {
    TABLET: 768,
    DESKTOP: 1024
}

export {
    BREAKPOINTS
}
